
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-alert',
  templateUrl: './app-alert.component.html',
  styleUrls: ['./app-alert.component.scss'],
  standalone: false
})
export class AppAlertComponent {

  @Input() type: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark' = 'info';

  @Input() dismissible = true;

  @Output() onClosed = new EventEmitter<void>();

  close() {
    this.onClosed.emit();
  }
}